// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import Tooltip from 'bootstrap/js/dist/tooltip';

// tooltips need to be initialized manually
// const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
// tooltipTriggerList.map(function (tooltipTriggerEl) {
//   return new Tooltip(tooltipTriggerEl);
// });

try {
    const breakpoint = window.matchMedia(
        `(min-width: ${window.bsDropdownHoverBreakpoint || 992}px)`
    );

    (function ($bsdd) {
        const CLASS_NAME = 'has-child-dropdown-show';
        $bsdd.prototype.toggle = (function (_orginal) {
            return function () {
                document
                    .querySelectorAll('.' + CLASS_NAME)
                    .forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                let dd = this._element
                    .closest('.dropdown')
                    .parentNode.closest('.dropdown');
                for (
                    ;
                    dd && dd !== document;
                    dd = dd.parentNode.closest('.dropdown')
                ) {
                    dd.classList.add(CLASS_NAME);
                }
                return _orginal.call(this);
            };
        })($bsdd.prototype.toggle);

        document
            .querySelectorAll(
                '.navbar-nav .dropdown, .dropdown.dropdown-hover-open'
            )
            .forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation(); // do not need pop in multi level mode
                });

                dd.addEventListener('mouseenter', function (e) {
                    if (breakpoint.matches) {
                        let toggle = e.target.querySelector(
                            ':scope>[data-bs-toggle="dropdown"]'
                        );
                        if (!toggle.classList.contains('show')) {
                            $bsdd.getOrCreateInstance(toggle).toggle();
                            dd.classList.add(CLASS_NAME);
                            $bsdd.clearMenus(e);
                        }
                    }
                });
                dd.addEventListener('mouseleave', function (e) {
                    if (breakpoint.matches) {
                        let toggle = e.target.querySelector(
                            ':scope>[data-bs-toggle="dropdown"]'
                        );
                        if (toggle.classList.contains('show')) {
                            $bsdd.getOrCreateInstance(toggle).toggle();
                        }
                    }
                });
            });
    })(Dropdown);
} catch (error) {
    console.error(error);
}
